@if (multiple) {
    <label>{{ placeholder | translate }}</label>
    @for (simpleUser of multipleSimpleUsers; track simpleUser) {
        <sag-ui-chip
            sag-ui-tooltip
            [tooltip]="simpleUser.id + ', ' + simpleUser.eMail"
            [selected]="true"
            [removable]="true"
            (remove)="removeValue(simpleUser)"
        >
            {{ simpleUser?.isExternal ? simpleUser?.userData?.fullName : simpleUser?.fullName }}
        </sag-ui-chip>
    }
    @if (!readonly) {
        @if (IS_TRS_PROJECT) {
            @if (!maxLength || multipleValue.length < maxLength) {
                <sag-ui-button [square]="true" (click)="openDialog()">
                    <fa-icon icon="user-plus"></fa-icon>
                </sag-ui-button>
            }
        } @else if (IS_PRODUCT_SAFETY_PROJECT) {
            <sag-ui-button [square]="true" (click)="openDialog()">
                <fa-icon icon="user-plus"></fa-icon>
            </sag-ui-button>
        }
    }
} @else {
    <label>{{ placeholder | translate }}</label>
    <input
        [required]="required"
        [value]="singleValue ? user?.userData?.fullName || simpleUser?.fullName : ''"
        matInput
        readonly
    />
    @if (!readonly) {
        @if (!value) {
            <sag-ui-button [square]="true" (click)="openDialog()">
                <fa-icon icon="user-plus"></fa-icon>
            </sag-ui-button>
        } @else {
            <sag-ui-button [icon]="'delete'" [square]="true" (click)="value = null" />
        }
    }
}
